module.exports = __webpack_public_path__ + "static/media/cta-shape.e995a998.png";